import { useMemo } from 'react'

import { SanityImage } from 'src/components/atoms/SanityImage'
import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'

import { ImageTilesRebrand } from 'src/config/generated/sanitySchema'

const ImageTilesSectionRebrand = ({ title, images }: ImageTilesRebrand) => {
  const gridClasses = useMemo(() => {
    switch (images?.length) {
      case 3:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-1'
      case 4:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-1'
      case 6:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2'
      case 8:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2'
      default:
        return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
    }
  }, [images])

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      <div className='flex flex-col'>
        <div className='flex flex-col items-center! mx-[30px] text-center mb-6'>
          {title && (
            <TypographyRebrand variant='h4' color='forestDeep'>
              {title}
            </TypographyRebrand>
          )}
        </div>
        <div className=' gap-5 flex flex-col items-center'>
          <div className={`w-full gap-5 grid ${gridClasses}`}>
            {images?.map((image, idx) => (
              <SanityImage
                className='w-full h-full'
                width={270}
                height={100}
                key={idx}
                alt={`image ${idx + 1}`}
                source={image}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageTilesSectionRebrand
